import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ wrapperClassName = "", className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"] || "password";
  return (
    <div className={`relative ${wrapperClassName}`}>
      <Input {...props} type={show ? "text" : "password"} className={`pr-11 ${className}`} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-slate-700 transition-colors"
        data-testid={`${tid}-toggle`}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
